export class ToggleAgendasMenuFilters {
  static readonly type = '[ToggleAgendasMenuFilters] action';
}
